/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './ReviewConfirmation.module.scss'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import { useSelector, useDispatch } from 'react-redux'
import DriverInformation from './DriverInformation'
import DrivingSchoolInformation from './DrivingSchoolInformation'
import { postTransactionAction } from 'redux/reducers/apiReducers/postTransactionReducer'
import { screenLoadingAction } from 'redux/actions'
import { useLocation } from 'react-router'
import BackAnchor from '../../../../shared/components/BackAnchor'
import DriverInfo from './DriverInfo'
import RoadTestInfo from './RoadTestInfo'
import { useHistory } from 'react-router-dom'

const ReviewConfirmationView = ({ t, i18n, setIsError }) => {
  let history = useHistory()
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [checkboxMessage, setCheckbocMessage] = useState(false)

  const [errMsg, setErrMsg] = useState('')

  const dispatch = useDispatch()

  const typeRoadTest = useSelector((state) => state.driver.driverInformation.typeRoadTest)
  const masterNumber = useSelector((state) => state.driver.driverInformation.masterNumber)
  const driverFirstName = useSelector((state) => state.driver.driverInformation.driverFirstName)
  const driverLastName = useSelector((state) => state.driver.driverInformation.driverLastName)
  const dateOfBirth = useSelector((state) => state.driver.driverInformation.dateOfBirth)
  const emailAddress = useSelector((state) => state.driver.driverInformation.emailAddress)
  const schoolPhoneNumber = useSelector((state) => state.driver.driverInformation.phoneNumber)

  const drivingSchoolName = useSelector((state) => state.drivingSchool.drivingSchoolInformation.drivingSchoolName)
  const contactName = useSelector((state) => state.drivingSchool.drivingSchoolInformation.contactName)
  const driverPhoneNumber = useSelector((state) => state.drivingSchool.drivingSchoolInformation.phoneNumber)

  const userIdentifier = useSelector((state) => state.register.uniqueID)

  const [fulfillmentStatusError, setFulfillmentStatusError] = useState()
  const location = useLocation()
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const fulfillmentStatus = params.get("fulfillmentStatus");
    if (fulfillmentStatus === "SENTFORPAYMENT") {
      setFulfillmentStatusError('review_confirmation.server_error')
    }
  }, [location])

  const getTransactionData = () => {
    try {
      let businessData = {}
      let parsedDriverFirstName = driverFirstName
      let parsedDriverLastName = driverLastName
      let parsedContactName = contactName
      let driverInformation = {
        typeRoadTest,
        masterNumber,
        parsedDriverFirstName,
        parsedDriverLastName,
        dateOfBirth,
        emailAddress,
        phoneNumber: schoolPhoneNumber,
      }

      let drivingSchoolInformation = {
        drivingSchoolName,
        parsedContactName,
        phoneNumber: driverPhoneNumber,
      }

      businessData['driverInformation'] = driverInformation
      businessData['drivingSchoolInformation'] = drivingSchoolInformation
      let data = {}
      data['businessData'] = JSON.stringify(businessData)
      data['businessServiceType'] = 'PAYROADTEST'
      data['lang'] = i18n.language.toString()
      data['useridentifier'] = userIdentifier.toString()
      return data
    } catch (err) {
      console.log(err)
      throw err
    }
  }

  const confirmationClick = () => {
    try {
      if (confirmChecked) {
        setCheckbocMessage(false)
        dispatch(screenLoadingAction())
        dispatch(postTransactionAction(getTransactionData()))
          .then((res) => {
            dispatch(screenLoadingAction())
            let transId = res['data']['id']
            let uuid = res['data']['useridentifier']
            let paymentURL = `/services/transactionservice/api/nspayredirect?transId=${transId}&transOwner=${uuid}`
            window.location.assign(`${window.location.origin}${paymentURL}`)
          })
          .catch((e) => {
            dispatch(screenLoadingAction())
            console.log(e)
            setErrMsg('review_confirmation.server_error')
          })
      } else {
        setCheckbocMessage(true)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const backNextProps = {
    prevText: t('review_confirmation.back'),
    prevURL: `/${i18n.language}${t('routes.driver_info')}`,
    nextText: t('review_confirmation.proceed_to_payment'),
  }

  const editDriverInfoOnClick = () => {
    history.push(`/${i18n.language}${t('routes.driver_info')}`)
  }

  // const driverSchoolInfoUrl = window.location.origin + `/${i18n.language}/driving-school-info`;

  // const editDriverSchoolInfoOnClick = () => {
  //   window.open(driverSchoolInfoUrl, '_self');
  // }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <BackAnchor />
          <h1>{t('title')}</h1>
        </div>
      </div>
      {fulfillmentStatusError && (
        <div className="row">
          <div className="col-xs-12 col-md-8" style={{ display: "flex" }}>
            <i
              className={['fa fa-exclamation-circle fa-2x', styles['exclamation_position'], styles['exclamation_color']].join(' ')}
              aria-hidden="true"
            />
            <div className={styles['error_message']} style={{ marginLeft: "1rem" }}>
              <div className="form-group has-error">
                <div ><h3 className="help-block">{t(fulfillmentStatusError)}</h3></div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h2>{t('review_confirmation.review_your_info')}</h2>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3 style={{ "display": "inline-block" }}>{t('review_confirmation.driver_information')}</h3>
          <a href="#" className={[styles['edit_button_right']].join(' ')}
            value={t('review_confirmation.edit')} name={t('review_confirmation.edit')} onClick={editDriverInfoOnClick}>
            {t('review_confirmation.edit')}<span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
          </a>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-md-8">
          <DriverInfo setIsError={setIsError} />
          <hr></hr>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3 style={{ "display": "inline-block" }}>{t('review_confirmation.road_test_info')}</h3>
          <a href="#" className={[styles['edit_button_right']].join(' ')}
            value={t('review_confirmation.edit')} name={t('review_confirmation.edit')} onClick={editDriverInfoOnClick}>
            {t('review_confirmation.edit')}<span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
          </a>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-md-8">
          <RoadTestInfo setIsError={setIsError} />
          <hr></hr>
        </div>
      </div>

      {/* <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3 style={{ "display": "inline-block" }}>{t('review_confirmation.driving_school_info')}</h3>
          <a href="#" className={[styles['edit_button_right']].join(' ')}
            value={t('review_confirmation.edit')} name={t('review_confirmation.edit')} onClick={editDriverSchoolInfoOnClick}>
            {t('review_confirmation.edit')}<span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
          </a>
        </div>
      </div> */}

      <div className="row">
        <div className="col-xs-12 col-md-8">
          <DrivingSchoolInformation setIsError={setIsError} />
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3>{t('review_confirmation.confirmation')}</h3>
          <p>{t('review_confirmation.verify_that_info')}</p>
          <ul>
            {/* <li>{t('review_confirmation.the_info_provided')}</li> */}
            <li>{t('review_confirmation.you_consent_to')}</li>
            <li>
              {t('review_confirmation.you_are_in_agreement')}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  i18n.language === 'en'
                    ? 'https://novascotia.ca/sns/services/help/terms-of-use.asp'
                    : 'https://novascotia.ca/sns/services/help/terms-of-use-fr.asp'
                }
              >
                {t('review_confirmation.terms_of_use')}
                <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
              </a>
              {t('review_confirmation.for_this_transaction')}
            </li>
          </ul>
          {/* <p>{t('review_confirmation.note_all_transaction')}</p> */}
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <label className="confirm_check_input" htmlFor="ConfirmationCheckBox">
            <input
              type="checkbox"
              id="ConfirmationCheckBox"
              value="confirm_check"
              onChange={(e) => {
                setConfirmChecked(e.currentTarget.checked)
              }}
              onBlur={() => {
                confirmChecked ? setCheckbocMessage(false) : setCheckbocMessage(true)
              }}
              checked={confirmChecked}
            />
            &nbsp;
            {t('review_confirmation.yes_information_is_correct')}&nbsp;
            {checkboxMessage ? (
              <i className={['fa fa-exclamation-circle', styles['exclamation_color']].join(' ')} aria-hidden="true"></i>
            ) : (
              ''
            )}
          </label>
          {checkboxMessage ? (
            <div className="form-group has-error">
              <div className="help-block">{t('review_confirmation.confirm_check_error')}</div>
            </div>
          ) : null}
        </div>
      </div>
      <div className={styles['error_margin']}>
        <BackNextButtons props={backNextProps} nextOnClick={confirmationClick} />
        {errMsg === '' ? null : (
          <i
            className={['fa fa-exclamation-circle', styles['exclamation_position'], styles['exclamation_color']].join(' ')}
            aria-hidden="true"
          />
        )}
      </div>
      {errMsg === '' ? null : (
        <div className={styles['error_message']}>
          <div className="form-group has-error">
            <div className="help-block">{t(errMsg)}</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default withTranslation('common')(ReviewConfirmationView)
